export enum BuSegmentMapping {
  'Biosimilars' = 'biosSegments',
  'Multiple Sclerosis' = 'imsSegments',
  'Spinal Muscular Atrophy' = 'smaSegments',
}
